if (!customElements.get('sunvivi-animated-showcase')) {
  customElements.define('sunvivi-animated-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.current = Number(this.dataset.slide) === 1 ? 1 : 0;
      this.prevArrow = this.querySelector('[data-sunvivi-direction="prev"]');
      this.nextArrow = this.querySelector('[data-sunvivi-direction="next"]');
      this.shop = this.querySelector('.sunvivi-showcase__shop');

      this.querySelectorAll('[data-sunvivi-direction]').forEach(button => {
        button.addEventListener('click', () => {
          this.applyState(this.current === 0 ? 1 : 0, true);
        });
      });

      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        this.applyState(this.current === 0 ? 1 : 0, true);
      });

      this.applyState(this.current, false);
    }

    applyState(index, announce) {
      this.current = index === 1 ? 1 : 0;
      this.dataset.slide = String(this.current);

      if (this.prevArrow) this.prevArrow.disabled = false;
      if (this.nextArrow) this.nextArrow.disabled = false;

      if (this.shop) {
        this.shop.textContent = this.shop.dataset[`label${this.current}`] || 'SHOP NOW';
        this.shop.href = this.shop.dataset[`link${this.current}`] || this.shop.href;
      }

      const status = this.querySelector('[data-sunvivi-status]');
      if (status) {
        status.textContent = `${this.current + 1} / 2`;
        if (announce) status.setAttribute('aria-live', 'polite');
      }
    }

    selectSlide(target) {
      const indexedTarget = target.closest('[data-sunvivi-slide-index]');
      if (!indexedTarget) return;
      this.applyState(Number(indexedTarget.dataset.sunviviSlideIndex), false);
    }
  });
}

document.addEventListener('shopify:block:select', event => {
  const showcase = event.target.closest('sunvivi-animated-showcase');
  if (showcase) showcase.selectSlide(event.target);
});
